<div style="padding: 24px;">
    <h5 mat-dialog-title class="text-center">Nuevo ciudad / Add City</h5>
    <div mat-dialog-content>
      <!--begin::Form-->
      <form class="form" [formGroup]="newCityForm" autocomplete="off" novalidate="novalidate" id="kt_login_form">
        <div class="form-group">
          <br-alert *ngIf="showAlert"></br-alert>
          <p><strong>ID: </strong>1</p>
          <p><strong>Fecha de creación / Date: </strong>{{date | date: 'MMMM d, y'}}</p>
          <mat-form-field class="w-100">
            <mat-label>Ciudad / City</mat-label>
            <input matInput type="text"
              formControlName="city" autocomplete="off" />
            <mat-error *ngIf="isControlHasError('city', 'required')">
              <strong>Campo requerido / Field Required</strong>
            </mat-error>
          </mat-form-field>
          <mat-form-field class="w-100">
            <input
              type="text"
              placeholder="País / Country"
              matInput
              formControlName="country"
              [matAutocomplete]="auto"
            >
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
              <mat-option *ngFor="let option of filteredCountries | async" [value]="option">
                {{option.name}}
              </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="isControlHasError('country', 'required')">
              <strong>Campo requerido / Field Required</strong>
            </mat-error>
          </mat-form-field>
        </div>
      </form>
      <!--end::Form-->
    </div>
    <div mat-dialog-actions>
      <button mat-button (click)="onNoClick(false)">Cerrar / Cancel</button>
      <button mat-button cdkFocusInitial (click)="submit(newCityForm)">Guardar / Save</button>
    </div>
</div>
